import { createSlice } from "@reduxjs/toolkit";
import { IAboutState } from "./aboutModel";
import {
  AboutDetailsImageUpload,
  getAboutDetails,
  updateAbout,
} from "./services/about.services";

const initialState: IAboutState = {
  loading: false,
  error: "",
  AboutDetails: {
    AboutDescription: "",
    VisionDescription: "",
    GoalDescription: "",
    MissionDescription: "",
  },
};

const aboutSlice = createSlice({
  name: "about",
  initialState,
  reducers: {
    clearAboutDetails: (state) => {
      state.AboutDetails = initialState.AboutDetails;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(updateAbout.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateAbout.fulfilled, (state) => {
      state.loading = true;
    });
    builder.addCase(updateAbout.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAboutDetails.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getAboutDetails.fulfilled, (state, action: any) => {
      state.loading = false;
      state.AboutDetails = action.payload;
    });
    builder.addCase(getAboutDetails.rejected, (state, action) => {
      state.loading = false;
      state.AboutDetails = initialState.AboutDetails;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(AboutDetailsImageUpload.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(AboutDetailsImageUpload.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(AboutDetailsImageUpload.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});
export const { clearAboutDetails } = aboutSlice.actions;
export default aboutSlice.reducer;
